(function () {
  var PROTECTION_HANDLE = 'shipping-protection';
  var LEGACY_PROTECTION_VARIANT_ID = '54033816650038';
  var PROTECTION_ATTRIBUTE = '_yp_shipping_protection';
  var PROTECTION_ATTRIBUTE_LABEL = 'Shipping Protection';

  function findProtectionLine(cart) {
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === LEGACY_PROTECTION_VARIANT_ID || item.handle === PROTECTION_HANDLE;
    });
  }

  function merchandiseItemCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (item.handle === PROTECTION_HANDLE) return sum;
      return sum + (item.quantity || 0);
    }, 0);
  }

  function updateHeaderCount(cart) {
    var count = merchandiseItemCount(cart);
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      if (count > 0) {
        el.setAttribute('data-header-cart-count', count);
        el.classList.add('visible');
      } else {
        el.setAttribute('data-header-cart-count', '');
        el.classList.remove('visible');
      }
    });
  }

  window.YPAdjustedCartItemCount = merchandiseItemCount;

  function cartRequest(path, body) {
    return fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function hasProtectionAttributes(cart) {
    return !!(cart.attributes && (cart.attributes[PROTECTION_ATTRIBUTE] || cart.attributes[PROTECTION_ATTRIBUTE_LABEL]));
  }

  function clearProtectionAttributes() {
    var attributes = {};
    attributes[PROTECTION_ATTRIBUTE] = '';
    attributes[PROTECTION_ATTRIBUTE_LABEL] = '';
    return cartRequest('/cart/update.js', { attributes: attributes });
  }

  function cleanupProtectionResidue(cart) {
    var legacyLine = findProtectionLine(cart);
    var changed = false;
    var request = Promise.resolve(cart);

    if (legacyLine) {
      changed = true;
      request = request.then(function () {
        return cartRequest('/cart/change.js', { id: String(legacyLine.key || LEGACY_PROTECTION_VARIANT_ID), quantity: 0 });
      });
    }

    if (hasProtectionAttributes(cart)) {
      changed = true;
      request = request.then(clearProtectionAttributes);
    }

    return request.then(function (updatedCart) {
      return { cart: updatedCart, changed: changed };
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(cleanupProtectionResidue)
      .then(function (result) {
        updateHeaderCount(result.cart);
        if (result.changed) window.location.reload();
      })
      .catch(function () {});
  });
})();
